import TwitterIcon from 'public/assets/social/icon-twitter.svg'

import encode from '../encodeForShare'

import css from './TwitterShareButton.module.css'

export type TwitterShareButtonProps = {
    title: string
    url: string
}

export default function TwitterShareButton({ title, url }: TwitterShareButtonProps) {
    const text = encode(`${title}${url ? ` ${url}` : ''}`)
    const twitterShareLink = `https://twitter.com/intent/tweet?text=${text}`

    return (
        /** having target=_blank, the new tab will altomatically close after sharing. */
        /**
         * The data handle is here so that if necessary this link can be updated after render
         * already finishes (like in the case of markedjs rendering).
         */
        <a
            target="_blank"
            data-share-link="twitter"
            rel="noopener noreferrer"
            href={twitterShareLink}
        >
            <TwitterIcon className={css.iconTwitter} />
        </a>
    )
}
